<template>
  <admin-wrapper
    title-translation-path="admin.FOLDERSTitle"
    :inputs="inputs"
    :moduleEnabler="moduleEnabler"
    :is-form-fetched="isFormFetched"
    @save="saveCard"
  >
    <template #visualization.input>
      <predefined-styles class="mb-16" :layer-id="layerId" :data-source-name="dataSourceName"></predefined-styles>
    </template>
    <template #featureCard.input>
      <draggable-lists-manage-card
        :layer-id="layerId"
        @update:hasAnyRequiredOnRightSide="hasAnyRequiredOnRightSide = $event"
        :has-edit-attributes="true"
      >
      </draggable-lists-manage-card>
    </template>
  </admin-wrapper>
</template>

<script>
import { call, get } from 'vuex-pathify';

import AdminWrapper from '@/components/AdminWrapper';
import DraggableListsManageCard from '@/components/DraggableListsManageCard';
import PredefinedStyles from '@/components/PredefinedStyles';

export default {
  name: 'FoldersSettings',
  components: {
    PredefinedStyles,
    DraggableListsManageCard,
    AdminWrapper,
  },
  data: () => ({
    isFormFetched: false,
    hasAnyRequiredOnRightSide: false,
  }),
  computed: {
    dataSourceName: get('admin/modulesMapping@folders.datasource_name'),
    layerId: get('admin/modulesMapping@folders.layer_id'),
    isModuleEnabled: get('admin/settingsValues@folders_module_enabled'),
    currentLayerSchema: get('layers/currentLayerSchema'),
    moduleEnabler() {
      return {
        name: 'folders_module_enabled',
        translationPath: 'admin.FOLDERS',
        subtitle: this.$i18n.t('admin.moduleEnablerSubtitle', { suffix: this.$i18n.t('admin.FOLDERS') }),
      };
    },
    inputs() {
      return [
        {
          name: 'visualization',
          subtitle: `admin.folderVisualizationSubtitle`,
          translationPath: 'admin.visualization',
          isCustom: true,
          align: 'start',
        },
        {
          name: 'featureCard',
          clearable: true,
          translationPath: 'admin.featureCard',
          isCustom: true,
          subtitle: this.$i18n.t('admin.setFeatureCard', { type: this.$i18n.t('admin.objectType') }),
          align: 'start',
        },
      ];
    },
  },
  methods: {
    getModulesMapping: call('admin/getModulesMapping'),
    getDataSourceForm: call('layers/getDataSourceForm'),
    getLayerMetadata: call('layers/getLayerMetadata'),
    getFeaturesLayer: call('layers/getFeaturesLayer'),
    editLayer: call('layers/editLayer'),
    async saveCard() {
      await this.editLayer({
        layer_type: 'features_layers',
        layer_id: this.layerId,
        body: {
          form_schema: {
            elements: this.currentLayerSchema,
          },
        },
      });
    },
    async init() {
      await this.getModulesMapping();
      await Promise.all([
        this.getDataSourceForm(this.dataSourceName),
        this.getFeaturesLayer(this.layerId),
        this.getLayerMetadata({ dataSource: this.dataSourceName }),
      ]);
      this.isFormFetched = true;
    },
  },
  watch: {
    isModuleEnabled(nV) {
      if (nV) {
        this.isFormFetched = false;
        this.init();
      }
    },
  },
  created() {
    if (this.isModuleEnabled) {
      this.init();
    } else {
      this.isFormFetched = true;
    }
  },
};
</script>

<style scoped></style>
